import Cookies from 'js-cookie';

export const setCookie = (name, value, options) => {
  const cookieOptions = options || {};
  cookieOptions.expires = cookieOptions.expires || 365;
  Cookies.set(name, value, cookieOptions);
};

const getCookie = (name) => Cookies.get(name);

export default getCookie;
